import ConnectionEdit from "../Edits/ConnectionEdit";
import CmModal from "../Controls/CmModal";

export default function ConnectionEditModal({ connectionId = 0, onClose }) {
  const id = Number.parseInt(connectionId, 10) || 0;
  const title = id > 0 ? "Connection Details" : "Add Connection";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="form"
      testId="connection-edit-modal"
    >
      <ConnectionEdit connectionId={id} onClose={onClose} />
    </CmModal>
  );
}
